<mat-form-field appearance="fill">
    <button
        mat-button
        matPrefix
        aria-label="Min 1"
        type="button"
        [disableRipple]="true"
        (click)="setCounter(counterForm.value-1)">
        -
    </button>
    <input matInput type="number"
           [formControl]="counterForm"
           [id]="id + '-input'"
           [min]="min"
           [max]="max"/>
    <button
        mat-button
        matSuffix
        aria-label="Plus 1"
        type="button"
        [disableRipple]="true"
        (click)="setCounter(counterForm.value+1)">
        +
    </button>
</mat-form-field>
